import { Box, Button, Stack, TablePagination, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SubscriptionCard from "../../components/subscriptions/SubscriptionCard";
import SubscriptionCardLoading from "../../components/subscriptions/SubscriptionCardLoading";
import useSubscriptionContext from "../../contexts/SubscriptionContext";

function SubscriptionTab() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const { totalSubscriptionsCount, activeSubscriptions, page, size, setPage, setSize, isLoadingSubscriptions } =
		useSubscriptionContext();

	function handleChangePage(event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) {
		setPage(newPage);
	}

	function handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
		setSize(parseInt(event.target.value, 10));
		setPage(0);
	}

	return (
		<>
			<>
				<Typography variant="h5" component="h2" textAlign={"center"}>
					{t("subscriptionPage.current")}
				</Typography>

				<Stack spacing={4} maxWidth={"sm"} sx={{ mt: 2 }} mx={"auto"}>
					{isLoadingSubscriptions && <SubscriptionCardLoading showActions={true} />}
					{!isLoadingSubscriptions &&
						activeSubscriptions?.map((subscription) => (
							<SubscriptionCard subscription={subscription} key={subscription.id} showActions={true} />
						))}
					{totalSubscriptionsCount >= size && (
						<TablePagination
							count={totalSubscriptionsCount}
							page={page}
							rowsPerPage={size}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							component="div"
							rowsPerPageOptions={[5, 10, 25]}
						/>
					)}
				</Stack>
				<Box display={"flex"} justifyContent={"center"}>
					<Button
						variant="contained"
						onClick={() => navigate("/account/subscription/purchase")}
						sx={{ mt: 4, mx: "auto" }}
					>
						{t("subscriptionPage.new")}
					</Button>
				</Box>
			</>
		</>
	);
}

export default SubscriptionTab;
